import { Injectable } from "@angular/core";
import { AreaOfWork } from "@models/areaOfWork.model";
import BaseService from "./base.service";

/**
 * A variant of the BaseService where the area of work's information is stored.
 *
 * @class AreaOfWorkService
 * @augments {BaseService<AreaOfWork>}
 */
@Injectable({
  providedIn: "root",
})
export class AreaOfWorkService extends BaseService<AreaOfWork> {}
